export class SendEmailModel {
    messageTemplateId: number;
    objectId: number;
    email: string;
}
